export default __webpack_public_path__ + "static/media/View.7931eceb.svg";